
export class ViewDispatch
{
    dispatchId: any;
}
